var map = {
	"./batch_help.jpg": "./src/assets/img/batch_help.jpg",
	"./oneSignal_help.jpg": "./src/assets/img/oneSignal_help.jpg",
	"./wonderpush_help.jpg": "./src/assets/img/wonderpush_help.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*_help\\.jpg$";